import React from 'react';
import { useTranslation } from 'react-i18next';
import './TeensHero.css'; 
import OrangeGradientButton from '../ui/OrangeGradientButton/OrangeGradientButton';
import TeensBG from '../../assets/Images/bg/teens.png';
import Glow from '../../assets/elements/glow.svg';
import TeenBrain from '../../assets/elements/TeenBrain.png'; 
import LeftElement from './../../assets/Images/teens/1.png';
import RightElement from './../../assets/Images/teens/2.png';
import LocationBadge from '../ui/LocationBadge/LocationBadge';

const TeensHero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      {/* Full-width Image Header */}
      <div 
        className="teens-hero-image" 
        style={{ backgroundImage: `url(${TeensBG})` }}
      ></div>

      {/* CTA Section */}
      <div className="teens-hero-cta">
        <img src={Glow} alt="glow" className="glow" />
        <img src={TeenBrain} alt="TeenBrain" className="TeenBrain" />
        <img src={LeftElement} alt="l" className="left-element-teens" />
       <p className='age-bage'> {t("ages")}</p>
        <p className="teens-hero-date">{t("teens_hero_date")}</p>
        <h1 className="teens-hero-title">{t("teens_hero_title")}</h1>
        
        <div className='button-container'>
          <a href="https://wa.me/message/KDMFDNPQYTU2G1" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
            <OrangeGradientButton width='300px'>
              {t("teens_hero_button")}
            </OrangeGradientButton>
          </a>
        </div>

        <img src={RightElement} alt="l" className="right-element-teens" />
      </div>
    </div>
  );
};

export default TeensHero;
